{
  "paymentLink": "https://nowpayments.io/payment/?iid=5614353054",
  "period": "3 MONTHS",
  "badge": "",
  "price": "150",
  "styleType": "White",
  "isMostPopular": false,
  "title": "3 MONTHS ACCESS",
  "descriptionList": [
    "Access to Richard Swing Channel",
    "Access to Richard Scalping Channel",
    "Access to Richard Altcoin Channel",
    "All signals can be fully automated",
    "Highly active support from me"
  ],
  "id": "1"
}